import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b2e2c87&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0b2e2c87&prod&scoped=true&lang=css"
import style1 from "../../assets/css/front-admin.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2e2c87",
  null
  
)

export default component.exports